var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayTriangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M83.1841 52.558C83.7821 52.9119 84.2776 53.4154 84.6218 54.0191C84.9661 54.6227 85.1471 55.3056 85.1471 56.0005C85.1471 56.6954 84.9661 57.3783 84.6218 57.982C84.2776 58.5856 83.7821 59.0892 83.1841 59.443L46.0371 81.427C45.4297 81.7864 44.738 81.9787 44.0323 81.9844C43.3266 81.9901 42.6319 81.809 42.0188 81.4594C41.4058 81.1099 40.8961 80.6043 40.5415 79.9941C40.1869 79.3839 40.0001 78.6908 40.0001 77.985V34.015C40.0001 33.3093 40.1869 32.6161 40.5415 32.0059C40.8961 31.3957 41.4058 30.8902 42.0188 30.5406C42.6319 30.1911 43.3266 30.0099 44.0323 30.0156C44.738 30.0213 45.4297 30.2136 46.0371 30.573L83.1841 52.558Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M56 107.5C84.4427 107.5 107.5 84.4427 107.5 56C107.5 27.5573 84.4427 4.5 56 4.5C27.5573 4.5 4.5 27.5573 4.5 56C4.5 84.4427 27.5573 107.5 56 107.5Z",
    stroke: "white",
    strokeWidth: 9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayTriangle);
export default __webpack_public_path__ + "static/media/play-triangle.d7aec4e43146b800ac1947f5fa022774.svg";
export { ForwardRef as ReactComponent };